var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Check = function Check(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 7 6' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'check'
      ),
      React.createElement('path', { d: 'M.007 3.343c.027.206.128.4.293.534l2.433 1.961a.708.708 0 0 0 1.041-.157l3.074-4.385A.854.854 0 0 0 6.705.164.71.71 0 0 0 5.659.32L3.033 4.064l-1.839-1.48a.71.71 0 0 0-1.045.163.86.86 0 0 0-.142.596',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Check;
//# sourceMappingURL=Check.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Check.js